import type { Reference, Resource } from '@medplum/fhirtypes'
import { invariant } from '@seen/core/invariant'
import { parseReferenceString } from '@seen/core/utils'
import { useMemo } from 'react'

export function useReference<T extends Resource>(
  value: Reference<T> | string
): Reference<T> {
  return useMemo(() => {
    if (typeof value === 'string') {
      const parsed = parseReferenceString<T>(value)
      invariant(parsed, 'Invalid reference')
      return parsed
    }
    return value
  }, [value])
}
